/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { promptConfigurationsControllerCreate } from "./promptConfigurationsControllerCreate";
import { promptConfigurationsControllerFindAll } from "./promptConfigurationsControllerFindAll";
import { promptConfigurationsControllerFindOne } from "./promptConfigurationsControllerFindOne";
import { promptConfigurationsControllerRemove } from "./promptConfigurationsControllerRemove";
import { promptConfigurationsControllerUpdate } from "./promptConfigurationsControllerUpdate";

export function promptConfigurationsService() {
  return { promptConfigurationsControllerCreate, promptConfigurationsControllerFindAll, promptConfigurationsControllerFindOne, promptConfigurationsControllerUpdate, promptConfigurationsControllerRemove }
}